module.exports = __webpack_public_path__ + "img/cctvinspection_stopped.728d6c3a.svg";